<div class="metadata-tile-container">
    <div class="metadata-item-box" *ngFor="let item of data;trackBy:trackByFn">
        <div class="metadata-name" title="{{item.title}}">{{item.title}}</div>
        <div class="metadata-value" title="{{item.rawValue}}" [style.color]="item.color" [innerHTML]="item.value"
            [style.font-size]="item.fontSize + 'px'" *ngIf="!item.isFileColumn">
        </div>
        <div *ngIf="item.isFileColumn">
            <span class="metadata-value" (click)="downloadFile(value)" *ngFor="let value of item.value; let last=last"
                [style.font-size]="item.fontSize + 'px'">
                <span class="filename"
                    title="{{value.file}}{{value.extension}}">{{value.file}}{{value.extension}}</span><span
                    *ngIf="!last">,&nbsp;</span>
            </span>
        </div>
    </div>
</div>